import { render, staticRenderFns } from "./BaseFlyoutComponent.vue?vue&type=template&id=cdcf50a6&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdcf50a6')) {
      api.createRecord('cdcf50a6', component.options)
    } else {
      api.reload('cdcf50a6', component.options)
    }
    module.hot.accept("./BaseFlyoutComponent.vue?vue&type=template&id=cdcf50a6&", function () {
      api.rerender('cdcf50a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flyout/BaseFlyoutComponent.vue"
export default component.exports